// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--b547a";
export var btnActive = "styles-module--btnActive--10728";
export var color = "styles-module--color--c61cb";
export var colorWrap = "styles-module--colorWrap--7acd1";
export var divider = "styles-module--divider--10f6f";
export var editor = "styles-module--editor--544a2";
export var label = "styles-module--label--4a6cc";
export var root = "styles-module--root--92f0e";
export var select = "styles-module--select--5fef1";
export var toolbar = "styles-module--toolbar--941c6";
export var wrapper = "styles-module--wrapper--6347b";